// extracted by mini-css-extract-plugin
module.exports = {"dashCard":"Transfers_dashCard__1UIIA"};